@if (isFaIcon) {
  <fa-icon [icon]="faIcons[icon]" [attr.data-testid]="'fa-icon'"></fa-icon>
} @else {
  @if (isSvgFile) {
    <div
      class="inline-svg"
      [inlineSVG]="icon"
      [attr.data-testid]="'svg-icon'"
    ></div>
  } @else {
    <mat-icon [attr.data-testid]="'material-icon'"> {{ icon }} </mat-icon>
  }
}


